
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sync",
      function () {
        return require("private-next-pages/sync/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sync"])
      });
    }
  